module.exports = __webpack_public_path__ + "static/media/figure6.2be55ced.png";